/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:change', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Fix: Prestige v11 formId shadowing bug
// form.id gets shadowed by <input name="id">, breaking gallery image swap
document.addEventListener('variant:change', function(event) {
  if (event.detail && event.detail.formId instanceof Element) {
    
    // Stop the broken event before it reaches the gallery
    event.stopImmediatePropagation();
    
    // Re-dispatch with the correct string formId
    const form = event.target;
    const correctFormId = form.getAttribute('id');
    
    form.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        formId: correctFormId,
        variant: event.detail.variant,
        previousVariant: event.detail.previousVariant
      }
    }));
  }
}, true); // Capture phase — runs BEFORE the gallery listener